// Shared timestamp formatting that respects the user's 12h/24h preference.
// Business/reporting timezone is Asia/Kolkata to match backend calculations.
const TZ = 'Asia/Kolkata';

// Backend returns UTC timestamps, sometimes WITHOUT a timezone marker
// (e.g. "2026-09-06T11:37:40.774000"). JS parses such naive strings as LOCAL time,
// which shows IST users a time ~5h30m behind. Normalize naive values to UTC so the
// Intl formatter can convert them to Asia/Kolkata correctly.
function parseAsUtc(value) {
  if (value instanceof Date) return value;
  if (typeof value === 'string') {
    const hasTz = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(value.trim());
    const hasTime = /\d{2}:\d{2}/.test(value);
    let v = value.trim();
    if (hasTime && !hasTz) v = v.replace(' ', 'T') + 'Z';
    return new Date(v);
  }
  return new Date(value);
}

export function formatDateTime(value, timeFormat = '12h') {
  if (!value) return '-';
  const d = parseAsUtc(value);
  if (Number.isNaN(d.getTime())) return '-';
  try {
    return new Intl.DateTimeFormat('en-IN', {
      timeZone: TZ,
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: timeFormat !== '24h',
    }).format(d);
  } catch (e) {
    return d.toLocaleString();
  }
}

export function formatTime(value, timeFormat = '12h') {
  if (!value) return '-';
  const d = parseAsUtc(value);
  if (Number.isNaN(d.getTime())) return '-';
  try {
    return new Intl.DateTimeFormat('en-IN', {
      timeZone: TZ,
      hour: '2-digit',
      minute: '2-digit',
      hour12: timeFormat !== '24h',
    }).format(d);
  } catch (e) {
    return d.toLocaleTimeString();
  }
}
// Date only, still in the business timezone (prevents a UTC-evening instant showing yesterday's date).
export function formatDate(value) {
  if (!value) return '-';
  const d = parseAsUtc(value);
  if (Number.isNaN(d.getTime())) return '-';
  try {
    return new Intl.DateTimeFormat('en-IN', { timeZone: TZ, day: '2-digit', month: 'short', year: 'numeric' }).format(d);
  } catch (e) {
    return d.toLocaleDateString();
  }
}
